define(function(require) {
	//models
	const instrument_model = require('civicsModels/instrument_model');
  const card_config_model = require('civicsModels/portal/ui/instrument_setup_model');

	//collections
	const IPSCollection = require('civicsBase/ipsModelCollection');
	const instrument_types_collection = require('civicsCollections/instrument_types_collection');
	const subtypes_collection = require('civicsCollections/subtypes_collection');
	const instrument_list_collection = require('civicsCollections/portal/instrument_view_collection_plain');
	const milestone_collection = require('civicsCollections/milestone_collection');

	//views
	const paging_view = require('civicsViews/paging_view/v_lov_paging_view');

	//templates
	const tpl = require('../templates/t_lov_card_view_list.hbs');

	//utilities
	const view_manager = require('civicsUtils/view_manager');
	const utilities = require('../utilities/card_view_utilities');
	const CN = require('civicsUtils/constants.js');
	const radio = require('backbone.radio');
	const modal_region = require('civicsUtils/modal_region');
	const extendedFilterUtility = require('civicsUtils/extended_filter_utility');
	const general_utils = require('civicsUtils/general_utilities');
	const instrumentMappings = require('../instrumentMappings.js');
	const AvailableFeatures = require('civicsUtils/available_features');

	require('civicsUtils/canvas');

	return Marionette.LayoutView.extend({
		template:tpl,
		regions: {
			recordsListRegion: '.records-list',
			modalRegion: {
				selector: 'body .rhythm-modals',
				regionClass: modal_region
			}
		},
		ui: {

		},
		events: {

		},
		commonInitialize: function () {
			this.config.mappings = instrumentMappings.getInstrumentMapping();
			this.instrumentTypeChkBoxVals = [];
			this.subTypeChkBoxVals = [];
			this.milestoneChkBoxVals = [];
			// Default to resolved — child views override with their own fetch if milestones are enabled
			if (!this.publicMilestonesFetch) {
				this.publicMilestonesFetch = $.Deferred().resolve();
			}
			var instrumentTypeFilters = [{ property: 'showInPortal', value: 'Y' }];

			if (this.config.isUserLoggedIn === undefined) {
				this.config.isUserLoggedIn = true;
			}
			if (!this.config.isUserLoggedIn) {
				instrumentTypeFilters.push({ property: 'isPublic', value: 'Y' });
			}

			this.fetchCardConfig();
			this.typesFetch = $.Deferred();
			this.instrumentTypesCollection = new instrument_types_collection();
			this.instrumentTypesCollection.isInMyProjectCardView = this.config.isInMyProjects;
			this.instrumentTypesCollection.urlParameters = { filter: instrumentTypeFilters };
			this.instrumentTypesCollection.fetch(this.typeFetchOptions).done((response, status, xhrResponse) => {
				var typeChkBoxVals = this.instrumentTypesCollection.toJSON();

				_.forEach(typeChkBoxVals, (obj) => {
					if (obj.value.toLowerCase() != this.config.globalConfig.wizardProjectType.toLowerCase()) {
						this.instrumentTypeChkBoxVals.push(obj);
					}
				});

		
				this.typesFetch.resolve();

			}).fail(() => {
				this.typesFetch.resolve();
			});
			this.subTypesFetch = $.Deferred();
			if (this.config.includeSubType) {
				this.subTypesCollection = new subtypes_collection();
				this.subTypesCollection.fetch().done((response, status, xhrResponse) => {
					this.subTypeChkBoxVals = this.subTypesCollection.toJSON();
					this.subTypesFetch.resolve();

				}).fail(() => {
					this.subTypesFetch.resolve();
				});
			}
			else {
				this.subTypesFetch.resolve();
			}

			this.milestonesFetch = $.Deferred();
			if(AvailableFeatures.AdditionalDashboardFilters() && this.config.storedProcedureMode){
				this.milestoneCollection = new milestone_collection(); 
				// Fetch the data
				this.milestoneCollection.fetch().done((response) => {
					this.milestoneChkBoxVals = this.milestoneCollection.toJSON(); 
					this.milestonesFetch.resolve(); 
				});
			}

			this.recordCollection = new instrument_list_collection();
			this.recordCollection.lightweightextensions = true;
			this.recordCollection.storedProcedureMode = (this.config.storedProcedureMode) ? this.config.storedProcedureMode : false;
			this.recordCollection.isInMyProjects = this.config.isInMyProjects;
			this.recordCollection.filters = {};
			this.recordCollection.filters.And = this.filterAnd;
			this.recordCollection.useRelationshipView = this.config.useRelationshipView;

			if (this.commonInitPromise) {
				this.commonInitPromise.resolve();
			}
		},
		onShow: function () {
			this.setupPagingView();
		},
		fetchCardConfig: function () {
			var cardConfigModel = new card_config_model();
			cardConfigModel.portlet = this.config.portlet;
			if (!this.cardConfigPromise) {
				this.cardConfigPromise = $.Deferred();
			}
			cardConfigModel.fetch({
				success: function (model, response, options) {
					//console.log('success',model,response,options);
					//we need to use the model rather than the response, in order to get the parsed output.
					this.config.cardConfig = model.toJSON();
					this.cardConfigPromise.resolve();
				}.bind(this),
				error: function (model, response, options) {
					view_manager.errorToWindow(response);
				}
			});
		},
		setupPagingView:function(){
			$.when(this.cardConfigPromise, this.commonInitPromise).done(function(){
				this.pagingView = new paging_view({
					config:this.config,
					//this is the name of the attribute where teh state of the map
					//(e.g. hidden/showing) is stored in local storage
					mapStateName: this.mapStateName,
					mapConfigName:this.mapConfigName,
					mapRegionId: this.mapRegionId,
					collection:this.recordCollection,
					childView:this.config.rowView,
					sortOptions: this.getSortFields(),
					sortField: this.config.defaultSortBy, //make sure field is in sortoptions
					passThrough: this.passThrough,
					pageSize: isNaN(this.config.recordsPerPage) ? 15 : this.config.recordsPerPage,
					noResultsText:this.noResultsText,
					viewOptions: this.config.selectOptions,
					portletName: this.portletName,
					initialSearchHtml: this.initialSearchHtml,
					skipInitialSearch: this.config.skipInitialSearch
				});
				this.recordsListRegion.show(this.pagingView)
				this.updateCollectionWithHash();

				$.when(this.typesFetch, this.subTypesFetch, this.publicMilestonesFetch).done(function(){
					this.pagingView.triggerMethod('filterConfigDone', this.getFilterConfig(false));
				}.bind(this));
			}.bind(this));
		},
		updateCollectionWithHash: function(){
			let filterUrl = this.config.filterURL;
			let hashObj = undefined;

			if(filterUrl === undefined && this.config.useSessionStorage == true) {
				filterUrl = this.getHashFromSession();
			}

			if(filterUrl){
				// when the filterurl is not in JSON format, do the default filter and clear the invalid hash
				try{
					// remove to view critera flag
					hashObj = JSON.parse(extendedFilterUtility.unMinifyFilterString(filterUrl)); 
					hashObj = this.updateHashObjFilter(hashObj);
				}catch(err) {
					window.location.hash = ""; // clear the invalid hash
				}
			}
			if(!this.config.skipInitialSearch || filterUrl){
				var isFavoriteSearchDashboard = this.config.filterType === 'tasks' || this.config.filterType === 'projects';
				if(!hashObj && isFavoriteSearchDashboard && AvailableFeatures.AdditionalDashboardFilters()){
					$.when(this.config.defaultSearchCheckPromise).done(() => {
						this.pagingView.triggerMethod('updateCollectionWithHash', hashObj);
					});
				}else{
					this.pagingView.triggerMethod('updateCollectionWithHash', hashObj);
				}
			}
		},
		getHashFromSession: function(){
			let filterUrl = undefined;
			var sessionFilterWhole = App.sessionStorage.get('CIVICS', 'FILTER_' + this.config.filterType.toUpperCase() + '_DATA');
			if(sessionFilterWhole !== undefined) {
				var sessionFilter = sessionFilterWhole.split('/');
				if(sessionFilter.length == 2){
					let hashPage = sessionFilter[0];
					if(hashPage.indexOf(this.config.filterType) >= 0)
						filterUrl = sessionFilter[1];
				}
			}
			return filterUrl;
		},
		updateHashObjFilter: function(filterObj){
			if(filterObj){
				delete filterObj.dateCriteriaPicker;
				if(filterObj.extendedFilter && filterObj.extendedFilter.And){
					_.each(filterObj.extendedFilter.And, (and)=>{
						// handle View Criteria. Make sure the date is correct
						if(and.isViewCriteria){
							if(and.criteriaValue > 0){
								var from = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
								from.setDate(from.getDate() - and.criteriaValue);
								and.value = general_utils.dateTimeStringFromDate(from)
								delete and["isViewCriteria"];
								delete and["criteriaValue"];
							}
						}
					});
					filterObj.extendedFilter.And = filterObj.extendedFilter.And.filter((item)=> !item.isViewCriteria || item.criteriaValue>0);
				}
			}

			return filterObj;
		},
		getSortFields: function() {
			var initValues = [];
			var objectValues = [];
			var self = this;
			var portlet = this.config.cardConfigAttribute;
			$.each(this.config.cardConfig, function (key, value) {
				var instTypeFields = [];
				var myFields = {};
				var instTypeName = key;
				if(value.fields){
					$.each(value.fields,function(key,card){
						var jsonVar = {};
						instTypeFields = [];
						if(key.toLowerCase() == portlet.toLowerCase() || (self.config.sortFieldSetup != undefined && self.config.sortFieldSetup.indexOf(key.toLowerCase()) >= 0) ){
							myFields = card;
							$.each(myFields, function (fieldType, values) {
								instTypeFields = instTypeFields.concat(values);
							});

							if(key.toLowerCase() == portlet.toLowerCase()) {
								jsonVar[instTypeName] = instTypeFields;
							}
							else {
								jsonVar[key] = instTypeFields;
							}

							initValues.push(jsonVar);
						}
					});
				}
			});

			$.each(initValues, function (key, value) {
				$.each(value, function (instType, values) {
					for (var i = 0; i < values.length; i++) {
						var sortFieldText = i18n.t(utilities.getValueFromMappings(values[i], instType, 'sortFieldText', this.config.mappings));
						var friendlyText = !_.isEmpty(sortFieldText) ? sortFieldText : i18n.t(utilities.getValueFromMappings(values[i], instType, 'friendlyName', this.config.mappings));
						var sortFieldAttr = self.getSortFieldAttr(values[i], instType);
						var formatType = utilities.getValueFromMappings(values[i], instType, 'formatType', this.config.mappings);
						var isNullLast = utilities.getValueFromMappings(values[i], instType, 'IsNullLast', this.config.mappings);
						var isString = utilities.getValueFromMappings(values[i], instType, 'IsString', this.config.mappings);
						var dependentProperty = utilities.getValueFromMappings(values[i], instType, 'dependentProperty', this.config.mappings);
						var isDateTime = utilities.getValueFromMappings(values[i], instType, 'IsDateTime', this.config.mappings); 

						if (!_.isEmpty(sortFieldAttr)) {
							if(!(!this.config.storedProcedureMode && values[i] == 'primarySite') ){
								objectValues.push({text: friendlyText, value: sortFieldAttr, formatType: formatType, isNullLast: isNullLast, isString: isString, isDateTime: isDateTime, dependentProperty: dependentProperty});
							}
						}
					}
				}.bind(this));
			}.bind(this));

			var ret =  _.sortBy(_.uniq(objectValues, 'text'), 'text');
			if (this.postProcessSortFields) {
				ret = this.postProcessSortFields(ret);
			}
			return ret;
		},
		getSortFieldAttr: function(value, instType) {
			return utilities.getValueFromMappings(value, instType, 'sortField', this.config.mappings);
		},
		templateHelpers: function() {
			return {
				portletTitle:this.portletTitle
			};
		},
		/* End MArionett Functions */
		getDateFilters: function () {
			var statusDates = this.config.statusDates;
			var dateFilters = [];
			for (var key in statusDates) {
				if(!statusDates.hasOwnProperty(key)) {
					continue;
				}
				else{
					if(statusDates[key].showStatus){
						dateFilters.push({
							type: 'daterange',
							label: i18n.t(statusDates[key].label),
							propertyName: key,
							showSelect: true
						});
					}
				}
			}
			return dateFilters;
		},
		getFilterConfig: function (applyFilter) {
			//this should be implemented by the extending
		},
	});
});
